// src/store/thunks/paymentThunks.js

import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import paymentService from "../../../services/jewelleryPlan/paymentService";

// Create payment
export const createPaymentThunk = createAsyncThunk(
  "payments/createPayment",
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await paymentService.createPayment(paymentData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get all payments
export const getAllPaymentsThunk = createAsyncThunk(
  "payments/getAllPayments",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await paymentService.getAllPayments(filters);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get pending payments
export const getPendingPaymentsThunk = createAsyncThunk(
  "payments/getPendingPayments",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await paymentService.getPendingPayments(filters);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get payment by ID
export const getPaymentByIdThunk = createAsyncThunk(
  "payments/getPaymentById",
  async (paymentId, { rejectWithValue }) => {
    try {
      const response = await paymentService.getPaymentById(paymentId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Verify payment
export const verifyPaymentThunk = createAsyncThunk(
  "payments/verifyPayment",
  async ({ paymentId, verificationData }, { rejectWithValue }) => {
    try {
      const response = await paymentService.verifyPayment(
        paymentId,
        verificationData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Reject payment
export const rejectPaymentThunk = createAsyncThunk(
  "payments/rejectPayment",
  async ({ paymentId, rejectionData }, { rejectWithValue }) => {
    try {
      const response = await paymentService.rejectPayment(
        paymentId,
        rejectionData
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get plan payments
export const getPlanPaymentsThunk = createAsyncThunk(
  "payments/getPlanPayments",
  async ({ planId, filters }, { rejectWithValue }) => {
    try {
      const response = await paymentService.getPlanPayments(planId, filters);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Get customer payments
export const getCustomerPaymentsThunk = createAsyncThunk(
  "payments/getCustomerPayments",
  async ({ customerId, filters }, { rejectWithValue }) => {
    try {
      const response = await paymentService.getCustomerPayments(
        customerId,
        filters
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Clear payment error
export const clearPaymentError = createAction("payments/clearPaymentError");
